var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}]},[(_vm.teamUpdatePermission)?_c('vs-row',[_c('div',{staticClass:"vx-col w-full mb-base p-4"},[_c('vx-card',[_c('div',[_c('TeamsForm',{key:_vm.key,attrs:{"data":_vm.item,"isEditActive":true}})],1)])],1)]):_c('not-permission')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }